/**
 * "Vote for this next" on the Coming-to-REPSit.ai cards (Beta-1 plan P1-09, ⚑Q-19 adopted;
 * D03 §A.4.1 "Beta testers will vote on what comes next").
 *
 * Votes live on the voter's own preferences doc (`Hugo_UserPreferences/{uid}.iaVotes: string[]`,
 * owner-writable, admin-readable — `scripts/tally-ia-votes.cjs` sums them for Tim) and each new
 * vote also drops a `Hugo_Feedback` note (`type: 'ia_vote'`) so the Tell-the-Build-Team relay
 * (P7-10) delivers it by email like any other feedback. Un-voting only updates the preferences.
 */
import { doc, getDoc, setDoc, addDoc, collection, serverTimestamp, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase';
import { collections } from '../utils/firestore';
import { FEEDBACK_COLLECTION } from './feedbackService';

export async function getMyVotes(uid) {
  if (!uid) return [];
  const snap = await getDoc(doc(db, collections.userPreferences, uid));
  const v = snap.exists() ? snap.data().iaVotes : null;
  return Array.isArray(v) ? v : [];
}

/** Toggle a vote. Returns the new voted state (true = voted). */
export async function toggleVote({ user, assistant, organization = null, voted }) {
  if (!user?.uid || !assistant?.id) throw new Error('user and assistant are required');
  const ref = doc(db, collections.userPreferences, user.uid);
  const next = !voted;
  await setDoc(ref, { iaVotes: next ? arrayUnion(assistant.id) : arrayRemove(assistant.id), iaVotesUpdatedAt: serverTimestamp() }, { merge: true });
  if (next) {
    try {
      await addDoc(collection(db, FEEDBACK_COLLECTION), {
        type: 'ia_vote',
        message: `Vote for next Intelligent Assistant: ${assistant.name} — ${assistant.shortTitle || assistant.longTitle || ''}`,
        assistantId: assistant.id,
        page: { path: typeof window !== 'undefined' ? window.location.pathname : '', title: typeof document !== 'undefined' ? document.title : '' },
        organizationId: organization?.id || null,
        organizationName: organization?.name || null,
        uid: user.uid,
        email: user.email || null,
        displayName: user.displayName || null,
        status: 'new',
        createdAt: serverTimestamp(),
      });
    } catch (err) {
      console.warn('Vote recorded, relay note failed:', err?.message || err);
    }
  }
  return next;
}
